module.exports = __webpack_public_path__ + "img/DC.6d0b934e.png";